export type SuggestionAcceptanceFailureKind = 'stale' | 'uncertain';

export class SuggestionAcceptanceError extends Error {
  constructor(readonly kind: SuggestionAcceptanceFailureKind) {
    super(kind === 'stale' ? 'Document suggestion is stale' : 'Suggestion outcome is uncertain');
    this.name = 'SuggestionAcceptanceError';
  }
}

export function suggestionAcceptanceFailureKind(error: unknown): SuggestionAcceptanceFailureKind {
  return error instanceof SuggestionAcceptanceError ? error.kind : 'uncertain';
}
